module.exports = __webpack_public_path__ + "static/media/Task-Group.500562ea.png";